import React from "react";
import "./styles.scss";

//IMAGES
import background from "../../assets/images/pexels-lexovertoom-1109541.jpg";
import logo from "../../assets/logos/VIABILIDADE PRO (1).png";

import list1 from "../../assets/images/pexels-alexander-isreb-880417-1797418.jpg";
import list2 from "../../assets/images/pexels-ben-neale-123878-380337.jpg";
import list3 from "../../assets/images/pexels-conojeghuo-175771.jpg";
import list4 from "../../assets/images/pexels-gdtography-277628-950241.jpg";

const HomePage: React.FC = () => {
  const handleButtonClick = (): void => {
    const url = `https://docs.google.com/forms/d/1LlNiuQ-SwHbGjJS3JVTrjS_RG-IPOgB9ejWeVCGFC4g/viewform?edit_requested=true`;

    window.open(url, "_blank", "noopener noreferrer");
  };

  return (
    <div className="home-page">
      <section id="header">
        <div className="banner">
          <img src={background} />
          <img className="logo" src={logo} />
        </div>
      </section>
      <section id="link-list" className="padding-hor-24 padding-top-24">
        <div className="content">
          <h1>
            <b>
              Transforme sua Carreira com o Conhecimento Essencial para Projetar
              em São Paulo.
            </b>
          </h1>
          <p>
            Olá, eu sou <b>Marcelo Sbarra</b>, arquiteto e professor com mais de{" "}
            <b>20 anos</b> de experiência, e estou aqui para te ajudar a
            entender os pilares fundamentais para projetar em <b>São Paulo</b>.
            Juntos, vamos explorar a tríade essencial que todo arquiteto deve
            dominar: o <b>Plano Diretor Estratégico</b> (PDE), a{" "}
            <b>Lei de Parcelamento</b>, <b>Uso e Ocupação do Solo</b> (LPUOS) e
            o <b>Código de Obras e Edificações</b> (COE). Com esse conhecimento,
            você terá as ferramentas necessárias para enfrentar os desafios
            urbanos e alcançar <b>sucesso</b> na sua trajetória{" "}
            <b>profissional</b>, se destacando e conquistando{" "}
            <b>valorização no mercado</b>.
          </p>
          <p>
            <b>
              Está pronto para dar o próximo passo na sua carreira? Entre em
              contato agora e saiba mais!
            </b>
          </p>
          <button className="btn btn-primary" onClick={handleButtonClick}>
            Garanta sua Vaga
          </button>
        </div>
        <hr />
        <h3 className="no-margin">Mais sobre mim</h3>
        <p>Explore minhas redes para nos conhecermos melhor!</p>
        <ul>
          <li>
            <a
              href="https://marcelosbarra.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={list1} />
              <p>Mais de 10 anos de Conteúdo Acadêmico</p>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/marcelosbarra/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={list2} />
              <p>LinkedIn</p>
            </a>
          </li>
          <li>
            <a
              href="https://buscatextual.cnpq.br/buscatextual/visualizacv.do?metodo=apresentar&id=K4162409D4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={list3} />
              <p>Currículo Lattes</p>
            </a>
          </li>
          <li>
            <a
              href="https://viabilidade.pro"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={list4} />
              <p>Plataforma de Ensino | Em Breve</p>
            </a>
          </li>
        </ul>
      </section>
      <footer>
        <p className="disclaimer">
          Viabilidade.Pro | copyright © 2025 | All Rights Reserved
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
